'use client';

import { Box, Divider, Typography } from '@mui/material';

import { BuscaPatrocinadaKeywordItem } from '~/types/keywordPerformance';

type FieldProps = { label: string; value: string };

function Field({ label, value }: FieldProps) {
  const isEmpty =
    value === '' || value === null || value === undefined || value === '0';
  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: 0.25, minWidth: 0 }}
    >
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ whiteSpace: 'nowrap' }}
      >
        {label}
      </Typography>
      <Typography
        variant="body2"
        sx={{ fontWeight: isEmpty ? 400 : 600, whiteSpace: 'nowrap' }}
        color={isEmpty ? 'text.disabled' : 'text.primary'}
      >
        {isEmpty ? '—' : value}
      </Typography>
    </Box>
  );
}

type Props = { item: BuscaPatrocinadaKeywordItem };

export function KeywordApiExpandedRow({ item }: Props) {
  return (
    <Box
      sx={{
        px: 4,
        py: 2.5,
        backgroundColor: theme =>
          theme.palette.mode === 'light' ? '#F7F8FE' : '#111122',
        borderTop: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <Box sx={{ py: 1 }}>
        <Typography
          variant="overline"
          color="text.disabled"
          sx={{
            letterSpacing: 1,
            fontSize: '0.65rem',
            display: 'block',
            mb: 1,
          }}
        >
          Métricas de Custo
        </Typography>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
            gap: 2,
          }}
        >
          <Field label="CPM" value={item.cpm} />
          <Field label="CPI" value={item.cpi} />
          <Field label="CPC" value={item.cpc} />
        </Box>
      </Box>

      {item.anunciantes.length > 0 && (
        <>
          <Divider />
          <Box sx={{ py: 1 }}>
            <Typography
              variant="overline"
              color="text.disabled"
              sx={{
                letterSpacing: 1,
                fontSize: '0.65rem',
                display: 'block',
                mb: 1,
              }}
            >
              Anunciantes
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
              {item.anunciantes.map(name => (
                <Box
                  key={name}
                  sx={{
                    px: 1.25,
                    py: 0.5,
                    borderRadius: 1,
                    border: '1px solid',
                    borderColor: 'divider',
                    backgroundColor: theme =>
                      theme.palette.mode === 'light' ? '#fff' : '#1A1A2E',
                  }}
                >
                  <Typography variant="caption" sx={{ fontWeight: 600 }}>
                    {name}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
}
